/****************************************************************************************************
* coming -> page-coming
****************************************************************************************************/



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// let comingIsSnippet = true;
// if(comingIsSnippet && typeof comingIsRevert !== 'undefined') comingScrollClear();



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Variables & Functions
let comingSel = '.page-coming .sector.hero ';


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Scroll & Animation
let comingShowTl; // eslint-disable-line no-unused-vars


////////////////////////////////////////////////// Init
const comingInit = (gsapRef) => {
  gsapRef.set(`${comingSel} .contents-wrapper`, {opacity: 0});
  
  gsapRef.set(`${comingSel} .sector-copy.title`, {opacity: 0, innerHTML: 'COMING SOON'});
  
  gsapRef.set(`${comingSel} .sector-copy.sentence`, {opacity: 0, y:' -50%'});
  
  gsapRef.set(`.sector.hero .button-container`, {opacity: 0, scaleY:'0.5'});
  gsapRef.set(`.sector.hero .button-copy`, {opacity: 0});
}


////////////////////////////////////////////////// Scroll
const comingScrollMake = (gsapRef, scrollTriggerRef, smootherRef) => {

  ////////////////////////////// Coming Soon show
  comingShowTl = gsapRef.timeline({
    // onStart: () => {},
    // onComplete: () => {},
    // onReverseComplete: () => {}
  })
  .addLabel('t0', 0)
    
  .to(`${comingSel} .contents-wrapper`, {duration: 0.4, opacity: 1, ease: 'power1.in'})
  .to(`${comingSel} .sector-copy.title`, {duration: 0.3, opacity: 1, ease: 'power1.out' }, 't0+=1')
  .to(`${comingSel} .sector-copy.title`, {duration: 2,
    scrambleText: {text: "COMING SOON", chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZ", 
     revealDelay: 0.5, speed: 1, newClass: "scramble"}
  }, 't0+=1')
    
  .addLabel('t1', '-=1')
    
  .to(`${comingSel} .sector-copy.sentence`, {duration: 0.5, opacity: 1, y: '0%', ease: 'power1.out'}, 't1')

  .addLabel('t2', 't1+=0.2')
    
  .to(`.sector.hero .button-container`, {duration: 0.2, opacity: 1, ease: 'power1.out'},'t2')
  .to(`.sector.hero .button-container`, {duration: 0.3, scaleY:'1', ease: 'power1.out'}, 't2')
  .to(`.sector.hero .button-copy`, {duration: 0.4, opacity: 1, ease: 'power1.inOut'}, 't2+=0.1')
  ;
}


////////////////////////////////////////////////// Scroll: clear
const comingScrollClear = () => {
  if(comingShowTl) { comingShowTl.revert(); comingShowTl = null; }
}


////////////////////////////////////////////////// Code for snippet
// if(comingIsSnippet) {
//   comingInit(gsapRef);
//   comingScrollMake(gsapRef, scrollTrigger, smootherRef);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Elements Animation Control
const comingElsControl = (opt='play') => {
  if(opt === 'play') {
    document.querySelector(".page-coming .sector.hero .video-bg").play();

  } else {
    document.querySelector(".page-coming .sector.hero .video-bg").pause();
  }
}



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Resizing
const comingResizeStart = (gsapRef, scrollTriggerRef, smootherRef) => {
  console.log("[coming soon] Resize: START");
}

const comingResizeDone = (gsapRef, scrollTriggerRef, smootherRef) => {
  console.log("[coming soon] Resize: END");

  comingScrollClear();
  comingInit(gsapRef);
  comingScrollMake(gsapRef, scrollTriggerRef, smootherRef);
}

////////// Code for snippet
// let comingResizing = false;
// const comingResizeHandle = (e) => {
//   if(!comingResizing) {
//     comingResizing = true;
//     smootherRef.paused(true);
//     scrollTriggerRef.disable();

//     comingResizeStart(gsapRef, scrollTriggerRef, smootherRef, splitTextRef);
//   }

//   waitForFinalEvent(function() {
//     comingResizing = false;
//     smootherRef.paused(false);
//     scrollTriggerRef.enable();
//     scrollTriggerRef.refresh(); // jess: After resizing done, refresh the ScrollTrigger

//     comingResizeDone(gsapRef, scrollTriggerRef, smootherRef, splitTextRef, draggableRef);
//   }, 1000, 'comingResize');
// }
// if(comingIsSnippet) {
//   if(typeof comingIsRevert !== 'undefined') window.removeEventListener('resize', comingResizeHandleRef);
//   window.comingResizeHandleRef = comingResizeHandle;
//   window.addEventListener('resize', comingResizeHandleRef);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Control Key
////////////////////////////////////////////////// Play / Pause Elements animation
const comingControlKey = (key) => {
  if(!document.querySelector(".page-coming")) return;

  let opt = document.querySelector(".page-coming .sector.hero .video-bg").paused ? 'play' : 'pause';
  comingElsControl(opt);
  console.log(`[coming: control] [key: ${key} pressed] Elements animation: ${opt}`);
};

////////////////////////////////////////////////// Code for snippet
// const comingControlKeyHandler = (e) => { if(e.key === '0') comingControlKey(e.key); }
// if(comingIsSnippet) {
//  if(typeof comingIsRevert !== 'undefined') window.removeEventListener('keydown', comingControlKeyHandlerRef);
//   window.comingControlKeyHandlerRef = comingControlKeyHandler;
//   window.addEventListener('keydown', comingControlKeyHandlerRef);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// if(comingIsSnippet) var comingIsRevert = true;



//////////////////////////////////////////////////////////////////////////////////////////////////
/// Export
export {
  comingInit,
  comingScrollMake,
  comingScrollClear,
  // comingElsControl,
  comingResizeStart,
  comingResizeDone,
  comingControlKey
}